import { AudioMentionNew } from "@/types/MentionCard";
import { Button } from "@components/ui/button";
import { Trans } from "@lingui/react/macro";
import { SkipForwardIcon } from "lucide-react";
import {
  useMediaDispatch,
  useMediaSelector,
  MediaActionTypes,
} from "media-chrome/react/media-store";

export default function NextMentionButton({
  mentions,
  disabled,
}: {
  disabled: boolean;
  mentions: AudioMentionNew[];
}) {
  const dispatch = useMediaDispatch();
  const mediaCurrentTime =
    useMediaSelector((state) => state.mediaCurrentTime) ?? 0;

  return (
    <Button
      disabled={disabled}
      size="icon-sm"
      variant="ghost"
      className="rounded-full"
      onClick={() => {
        const nextMention = mentions.find(
          (m) => (m.indices_metadata?.start_time ?? 0) > mediaCurrentTime
        );

        if (nextMention) {
          const type = MediaActionTypes.MEDIA_SEEK_REQUEST;
          const detail = nextMention.indices_metadata?.start_time ?? 0;
          dispatch({ type, detail });
        }
      }}
    >
      <SkipForwardIcon className="fill-primary" />
      <span className="sr-only">
        <Trans>Nästa omnämnande</Trans>
      </span>
    </Button>
  );
}
